<script lang="ts">
import { goToModule } from '@/framework/base/helpers/NavHelper';
import { Fiches, Modules } from '@/generated/classes/AppSchema';
import { storeSession } from '@/generated/stores';
import Route from '@/extend/classes/Route';
import { Alerts } from '@/framework/base/helpers/Alerts';
import Dialog from '@/generated/classes/Dialog';
import { RessourceFwkControl, FwkControls } from '@/ressources/globalRessources';
import { defineComponent, type PropType } from "vue";
import {useRoute, useRouter} from "vue-router";

export default defineComponent({
  name: 'RedirectionView',
  components: {},
  props: {
    fiche: {
      type: Object as PropType<Fiches>
    }
  },
  data() {
    return {
      router: useRouter(),
      route: useRoute()
    }
  },
  created(): void {
    if (this.fiche == Fiches.PREFERENCE) {
      const user = storeSession.connectedUser;
      if (user && user.id > 0) {
        const route = new Route();
        route.module = Modules.PROFIL;
        route.fiche = Fiches.PREFERENCE;
        route.ficheObjId = user.id;
        goToModule(this.router, route);
      } else {
        const dialog = new Dialog();
        dialog.label = RessourceFwkControl(FwkControls.EXPIRED).label;
        Alerts.message(dialog).then((res) => {
          if (res) {
            storeSession.clearData();
            this.router.push({ name: "HomePage" });
          }
        });
      }
    }
  },

})

</script>
